import script from "./ai-assistant-permission.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-assistant-permission.vue?vue&type=script&setup=true&lang=js"

import "./ai-assistant-permission.vue?vue&type=style&index=0&id=33829ade&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33829ade"]])

export default __exports__